<template>
  <div>
    <md-menu md-size="medium" v-if="applications && applications.length">
      <md-button md-menu-trigger class="md-icon-button">
        <md-icon>apps</md-icon>
        <md-tooltip class="md-xsmall-hide md-small-hide" md-direction="left">{{ $t('my_applications') }}</md-tooltip>
      </md-button>

      <md-menu-content class style="max-height: 64vh; width: 290px;">
        <s1vm-user-applications></s1vm-user-applications>
      </md-menu-content>
    </md-menu>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  computed: {
    ...mapGetters('user', {
      applications: 'APPLICATIONS'
    })
  }
}
</script>
